import { printRoundedNumber } from '../../shared/utils';
import { dataTransformers } from '../shared/data-transformers';
import ItemPropertyTable, {
  ItemProperty,
  useDivider,
  useProperty,
} from './item-property-table';
import { Item } from './item-types';
import PropertyCard from './property-card';

type ShippingSpecProps = {
  title: string;
  specType: string;
  item: Item;
};

export default function ShippingSpec(props: ShippingSpecProps) {
  const { specType, item } = props;

  const spec = item.shippingSpecs.find((spec) => spec.type == specType);
  if (!spec) {
    return null;
  }

  let specs: ItemProperty[] = [];
  const caseL = printRoundedNumber(spec.caseLength, 0);
  const caseW = printRoundedNumber(spec.caseWidth, 0);
  const caseH = printRoundedNumber(spec.caseHeight, 0);
  specs.push(
    useProperty('Case Dims (L x W x H)', `${caseL} x ${caseW} x ${caseH} in`)
  );
  if (spec.caseWeight) {
    specs.push(
      useProperty(
        'Case Weight',
        spec.caseWeight,
        dataTransformers.unit('lbs', 0)
      )
    );
  }
  if (spec.caseWeight) {
    specs.push(
      useProperty('Case Pack', spec.caseQuantity, dataTransformers.integer)
    );
  }
  if (spec.palletWidth && spec.palletHeight && spec.palletLength) {
    specs.push(useDivider());
    const palletL = printRoundedNumber(spec.palletLength, 0);
    const palletW = printRoundedNumber(spec.palletWidth, 0);
    const palletH = printRoundedNumber(spec.palletHeight, 0);
    specs.push(
      useProperty(
        'Pallet Dims (L x W x H)',
        `${palletL} x ${palletW} x ${palletH} in`
      )
    );
  }

  if (spec.palletWeight) {
    specs.push(
      useProperty(
        'Pallet Weight',
        spec.palletWeight,
        dataTransformers.unit('lbs', 0)
      )
    );
  }
  if (spec.casePerPallet) {
    specs.push(
      useProperty('Case / Pallet', spec.casePerPallet, dataTransformers.integer)
    );
  }
  if (spec.casePerLayer) {
    specs.push(
      useProperty('Case / Layer', spec.casePerLayer, dataTransformers.integer)
    );
  }
  if (spec.caseQuantity) {
    specs.push(
      useProperty(
        'Units / Pallet',
        spec.caseQuantity * spec.casePerPallet,
        dataTransformers.integer
      )
    );
  }
  if (spec.tariffCode) {
    specs.push(useProperty('Tarrif Code', spec.tariffCode));
  }

  return (
    <PropertyCard title={props.title}>
      <ItemPropertyTable properties={specs} />
    </PropertyCard>
  );
}
